import { FIRST_ELEMENT, STEP } from '@constants';

interface ChartRange {
  xrange: number[];
  yrange: number[];
}

interface LineRange {
  xValueLine: number[];
  yValueLine: number[];
}

const adjustRange = (valueLine: number[], range: number[]) => {
  return (valueLine[FIRST_ELEMENT] - range[FIRST_ELEMENT]) / (range[STEP] - range[FIRST_ELEMENT]);
};

export const getChartGradient = (range: ChartRange, valueLine: LineRange) => {
  let [xstart, ystart, xend, yend] = [0, 0, 1, 1];

  if (range.xrange[FIRST_ELEMENT] < valueLine.xValueLine[FIRST_ELEMENT]) {
    const dev = adjustRange(valueLine.xValueLine, range.xrange);
    ystart += dev;
    yend -= dev;
  } else if (range.yrange[FIRST_ELEMENT] < valueLine.yValueLine[FIRST_ELEMENT]) {
    const dev = adjustRange(valueLine.yValueLine, range.yrange);
    xstart += dev;
    xend -= dev;
  }

  return { xstart, ystart, xend, yend };
};
